export default __webpack_public_path__ + "static/media/core-services.236e823b.svg";